module.exports = __webpack_public_path__ + "static/media/Search16px.713fea05.svg";